/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { dofStyles } from '../JSStyles/dofStyles';
import DOFHeader from './Header';
import { useParams } from 'react-router-dom';
import {
  Grid,
  Typography,
  RACModalCard,
  RACButton,
  RACTextbox,
  RACDatePicker,
  Paper,
  Box,
  RACSelect,
  RACMUIDatePicker
} from '@rentacenter/racstrap';
import { IncomeContext } from '../context/userInformation/IncomeContextProvider';
import { ResidenceContext } from '../context/userInformation/ResidenceContextProvider';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import { useHistory } from 'react-router-dom';
import DocumentCapture from '../common/camera/OpenCamera';
import { ReactComponent as UploadIcon } from './../images/uploadImage.svg';
import { ReactComponent as ImageIcon } from './../images/image-icon.svg';
import { ReactComponent as PdfIcon } from './../images/pdf-icon.svg';
import { ReactComponent as DeleteIcon } from './../images/delete-icon.svg';
import MessagePopup from '../common/MessagePopup';
import FileToPDFViewer from '../common/FileToPDFViewer';
import { handleFile, uploadDocuments } from '../common/helperFunction/HelperFunction';
import { CreateCustomerStg, UpdateCustomer } from '../api/user';
import ScreenLoader from '../common/loader/ScreenLoader';
import BreadCrumb from './BreadCrumb';
import {
  ACCEPTED_FILE_TYPES,
  SIZE_UNIT_KB,
  SIZE_UNIT_MB,
  SIZE_UNIT_GB,
  INCOME_TAB_DOCUMENT_LIST,
} from '../constants/constants';
import { useTranslation } from 'react-i18next';
import { getDateFormat } from '../utils/dateUtils';

const IncomeTab: React.FC = () => {
  const { t } = useTranslation();
  const dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
  const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
  const {
    incomeInformation,
    setIncomeInformation,
    setResidenceDoc,
    setFileSize,
    setFileType,
    fileType,
    fileSize,
    showResidenceVerfDocument,
    setShowResidenceVerfDocument,
    residenceDoc,
    typeOfIncomeOptions,
    jobTypeOptions,
    incomeSave,
    setIncomeSave,
    stgCustomerEmpId,
    consentDate
  } = useContext(IncomeContext) || {};

  const { identityInformation, stgCustomerProfileId, getCustomerRes, getStgCustomerRes, featureFlagDetails, storeDetails } =
    useContext(IdentityContext) || {};
  const { residenceInformation, setStgCustomerAddressId } =
    useContext(ResidenceContext) || {};
  // Get date format based on store region
  const dateFormat = getDateFormat(storeDetails, featureFlagDetails);

  interface RouteParams {
    customerId: string;
    tcid: string;
  }
  const { customerId, tcid } = useParams<RouteParams>();

  const [openPdf, setOpenPdf] = useState<boolean>(false);
  const [base64Files, setBase64Files] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [messagePopup, setMessagePopup] = useState<boolean>(false);
  const [showMoreDocuments, setShowMoreDocuments] = useState<boolean>(false);
  const [intialProof, setIntialProof] = useState<number>(3);
  const [isNextEnabled, setIsNextEnabled] = useState<boolean>(false);
  const [screenLoader, setScreenLoader] = useState<boolean>(false);
  const featureFlagDetailsString: any = window.sessionStorage.getItem("featureFlagDetails");
  const featureFlagDetail: any[] = featureFlagDetailsString ? JSON.parse(featureFlagDetailsString) : [];
  const canEnableCountryCode = featureFlagDetail.find((param: { paramKeyName: string; }) =>
    param.paramKeyName === 'CountryCode');
  const steps = [
    { label: 'Identity', isActive: true, isCompleted: true },
    { label: 'Code Confirmation', isActive: true, isCompleted: true },
    { label: 'Residence', isActive: true, isCompleted: true },
    { label: 'Income', isActive: true, isCompleted: false },
  ];

  // Error messages for validation
  const [errorMessages, setErrorMessages] = useState({
    companyName: '',
    jobPosition: '',
    joiningDate: '',

  });
  const classes = dofStyles();
  const history = useHistory();
  const { companyName, joiningDate, netMonthlyIncome, jobPosition, typeOfIncomeProof, jobType } =
    incomeInformation || {};

  // Check if all mandatory fields are filled
  useEffect(() => {

    const allFieldsFilled =
      !!typeOfIncomeProof?.length &&
        !!companyName?.length &&
        !!joiningDate?.length &&
        !!netMonthlyIncome?.length &&
        !!jobPosition?.length &&
        !!jobType?.length ? true : false;

    setIsNextEnabled(allFieldsFilled);
  }, [incomeInformation]);

  useEffect(() => {
    if (!residenceDoc) {
      setShowResidenceVerfDocument?.(false);
    } else if (residenceDoc) {
      setShowResidenceVerfDocument?.(true);
    }
  }, [residenceDoc, setShowResidenceVerfDocument]);

  // Handle input changes for text fields
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>,
    fieldName?: string
  ) => {
    const { name, value } = e.target;
    if (name == 'companyName' || name == 'jobPosition') {
      const regex = /^[a-zA-Z0-9 \u00C0-\u00FF]*$/;
      if (!regex.test(value)) {
        return;
      }
    }

    setIncomeInformation?.((prevState) => {
      const updatedState = {
        ...prevState,
        [fieldName || name]: value.trimStart(),
      };
      setErrorMessages((prev) => ({ ...prev, [fieldName || name]: '' }));

      // Check if all required fields are filled after updating the state
      const { typeOfIncomeProof, companyName, joiningDate, netMonthlyIncome, jobPosition, jobType } = updatedState;

      const allFieldsFilled =
        typeOfIncomeProof?.length &&
          companyName?.length &&
          joiningDate?.length &&
          errorMessages.joiningDate == '' &&
          netMonthlyIncome?.length &&
          jobPosition?.length &&
          jobType?.length ? true : false;

      setIsNextEnabled(allFieldsFilled); // Set next button enabled state based on filled fields

      return updatedState; // Return the updated state
    });
  };

  const validateForm = () => {
    const { companyName, joiningDate, netMonthlyIncome, jobPosition } =
      incomeInformation || {};

    const isCompanyNameValid =
      companyName &&
      companyName.length <= 30 &&
      /^[a-zA-Z0-9\s]*$/.test(companyName);
    const isJobPositionValid =
      jobPosition &&
      jobPosition.length <= 30 &&
      /^[a-zA-Z0-9\s]*$/.test(jobPosition);

    // Set error messages
    setErrorMessages({
      companyName: isCompanyNameValid
        ? ''
        : 'Company Name must be less than 30 characters.',
      jobPosition: isJobPositionValid
        ? ''
        : 'Job Position must be less than 30 characters.',
    });
  };

  const IncomeNextClick = async () => {
    setScreenLoader(true);
    if (incomeSave) {
      setScreenLoader(false);
      history.push('/submission');
    }
    validateForm();
    if (errorMessage.length) {
      setScreenLoader(false);
      return;
    }
    const takeHomePay = incomeInformation?.netMonthlyIncome && incomeInformation?.netMonthlyIncome !== "NaN"
      ? incomeInformation?.netMonthlyIncome.replace(/,/g, "")
      : "0";


    // Create payload
    const stgCustomerPayload = {
      stgCustomerProfileId: Number(stgCustomerProfileId) ? stgCustomerProfileId : undefined,
      action: Number(stgCustomerProfileId) ? "UPD" : "CRT",
      firstName: identityInformation.firstName || '',
      middleInitial: identityInformation.secondName || '',
      lastName: identityInformation.paternalLastName || '',
      maternalLastName: identityInformation.maternalLastName || '',
      gender: identityInformation?.gender ? identityInformation?.gender.toUpperCase() : '',
      dob: identityInformation.dateOfBirth || '',
      maritalStatus: identityInformation.maritalStatus || '',
      phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
      countryCode: canEnableCountryCode?.paramValue == '1' ? identityInformation.countryCode : undefined,
      emailId: identityInformation.emailId || '',
      referralSources: identityInformation.racPromotions || '',
      phoneType: 'CELL',
      callTime: 'MORN',
      submittedDate: new Date().toISOString().split('T')[0],
      storeNumber: window.sessionStorage.getItem('storeNumber'),
      productCode: sessionStorageValues?.productCode || getStgCustomerRes?.productCode || undefined,
      customerCreatedSource: sessionStorageValues?.clientId || getStgCustomerRes?.customerSource || undefined,
      customerId: sessionStorageValues?.type == 'EC' ? sessionStorageValues?.identifier : undefined,
      consentDate: getStgCustomerRes?.consentDate ?? consentDate ?? null,    
      employmentInfo: {
        ...(Number(stgCustomerEmpId) && { stgCustomerEmploymentId: stgCustomerEmpId }),
        companyName: incomeInformation?.companyName || '',
        takeHomePay: Number(takeHomePay),
        incomeSourceType: incomeInformation?.typeOfIncomeProof || '',
        jobType: incomeInformation?.jobType || '',
        jobPosition: incomeInformation?.jobPosition || '',
        empBeginDate: incomeInformation?.joiningDate || '',
        empVerificationStatus: getStgCustomerRes?.employmentInfo?.employmentVerification == "APPROVED" && Number(stgCustomerEmpId) ? 'APPROVED' : 'PENDING',
      },
    };

    console.log('Payload::', stgCustomerPayload);

    // Update Customer Payload

    let updateCustomerPayload: any = ''
    sessionStorageValues?.type == 'EC' ?
      updateCustomerPayload = {
        employerReferences: [{
          employerReferenceId: (getCustomerRes?.employerReferences && getCustomerRes?.employerReferences?.length > 0) 
    ? getCustomerRes?.employerReferences?.[0].employerReferenceId 
    : '',
          employerName: incomeInformation?.companyName || '',
          takeHomePay: String(takeHomePay),
          incomeSourceType: incomeInformation?.typeOfIncomeProof || '',
          jobType: incomeInformation?.jobType || '',
          jobPosition: incomeInformation?.jobPosition || '',
          employmentBeginDate: incomeInformation?.joiningDate || '',
        }],
        customerId: sessionStorageValues?.identifier || '',

      } : null;

    const stgCusProfId = stgCustomerProfileId;
    debugger
    if (residenceDoc) {
      console.log('Income data', residenceDoc);
      const documentData = await handleFile(residenceDoc);

      // Check if customerId or tcid is valid
      console.log('stgCusProfId ', stgCusProfId, customerId, tcid);

      if (stgCusProfId) {
        const uploadResult = await uploadDocuments(
          stgCusProfId,
          [{ documentType: 'EMPDOC', file: documentData?.base64String }],
          customerId
        );
        if (!uploadResult) {
          setScreenLoader(false);
          setMessagePopup(true);
          setErrorMessage(t('Document upload failed. Please try again with a smaller file.'));
          return;
        }
      } else {
        console.error('Both customerId and tcid are null or invalid.');
      }
    }
    const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
    console.log('isStoreCodeFlow ', isStoreCodeFlow);
    const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
    const response: any = sessionStorageValues?.type !== 'EC' ? await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken)]) : await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken), UpdateCustomer(updateCustomerPayload, isStoreCodeFlow, accessToken)]);
    debugger
    if (response[0]?.status == '200') {
      setIncomeSave?.(true);
      history.push('/submission');
    }
    setScreenLoader(false);
  };

  // Hanlde Date change
  const handleDateChange = (date: string) => {
    const selectedDate = new Date(date);
    const minDate = new Date('1900-01-01');
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    setErrorMessages((prev) => ({ ...prev, joiningDate: '' }));

    if (selectedDate >= minDate && selectedDate <= currentDate) {
      setIncomeInformation?.((prevState) => {
        const updatedState = {
          ...prevState,
          joiningDate: date,
        }
        // Check if all required fields are filled after updating the state
        const { typeOfIncomeProof, companyName, joiningDate, netMonthlyIncome, jobPosition, jobType } = updatedState;

        const allFieldsFilled =
          typeOfIncomeProof?.length &&
            companyName?.length &&
            joiningDate?.length &&
            netMonthlyIncome?.length &&
            jobPosition?.length &&
            jobType?.length ? true : false;

        setIsNextEnabled(allFieldsFilled); // Set next button enabled state based on filled fields

        return updatedState; // Return the updated state
      });

    } else {
      setIsNextEnabled(false);
      setErrorMessages((prev) => ({
        ...prev,
        joiningDate: 'Please enter the valid Date',
      }));
    };

  };

  const pdfModelContent = () => {
    return <FileToPDFViewer file={residenceDoc} />;
  };

  // Handle file input changes
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      handleFiles(Array.from(files));
    }
  };

  // Handle file drop event
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    console.log('handleDrop', event.dataTransfer.files);
    handleFiles(Array.from(event.dataTransfer.files));
  };

  // Process selected files
  const handleFiles = async (files: File[]) => {
    const validFiles = files.filter((file) =>
      ACCEPTED_FILE_TYPES.includes(file.type)
    );

    setUploadedFiles((prev) => [...prev, ...validFiles]);

    // Convert each file into a Base64 string
    const base64Promises = validFiles.map((file) => convertToBase64(file));
    const base64Results = await Promise.all(base64Promises);

    // Save Base64 results to state
    setBase64Files((prev) => [...prev, ...base64Results]);

    handleFileDetails(files);
  };

  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(new Error('Failed to convert file.'));
      reader.readAsDataURL(file);
    });
  };

  const handleFileDetails = (files: any) => {
    const fileSizeInBytes = files[0].size;
    setFileType?.(files[0].type);
    setResidenceDoc?.(files[0]);

    let fileSize: any = fileSizeInBytes;
    let sizeUnit = 'bytes';

    if (fileSizeInBytes >= 1024) {
      fileSize = fileSizeInBytes / 1024;
      sizeUnit = SIZE_UNIT_KB;
    }
    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_MB;
    }
    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_GB;
    }

    fileSize = fileSize.toFixed(2);
    setFileSize?.(`${fileSize} ${sizeUnit}`);

    const isAcceptedType = ACCEPTED_FILE_TYPES.includes(files[0].type);
    // const isPdf = files[0].type === 'application/pdf';
    const fileSizeNumber = Number(fileSize);

    if (!isAcceptedType) {
      setMessagePopup(true);
      setErrorMessage(
        'Invalid file format. Please upload a PDF, JPEG, or PNG.'
      );
      setResidenceDoc?.('');
      return;
    }

    if (sizeUnit === SIZE_UNIT_KB) {
      setShowResidenceVerfDocument?.(true);
      return;
    }

    if (sizeUnit === SIZE_UNIT_MB && fileSizeNumber >= 5) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 5MB.');
      setResidenceDoc?.('');
      return;
    }

    if (
      (sizeUnit === SIZE_UNIT_MB && fileSizeNumber > 20) ||
      sizeUnit === SIZE_UNIT_GB
    ) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 20MB.');
      setResidenceDoc?.('');
      return;
    }

    setShowResidenceVerfDocument?.(true);
  };

  return (
    <>
      {screenLoader ? <ScreenLoader /> : false}
      <DOFHeader
        identity={true}
        residence={true}
        income={false}
        reference={false}
        activeStep="Please give us some details about your residence"
      />
      <BreadCrumb steps={steps} />
      {messagePopup ? (
        <MessagePopup
          value={{
            message: errorMessage,
            setFunction: setMessagePopup,
            cleanupFunction: setErrorMessage,
          }}
        />
      ) : null}
      <Grid className={classes.referenceContainer1}>
        <Grid className={classes.referenceSection}>
          <Grid>
            <Grid>
              <Typography>{t("Proof of Income")}</Typography>
            </Grid>
            <Grid>
              <Typography>
                {t("Accepted proof of Income documents, Listed Below (Choose One):")}
              </Typography>
            </Grid>
            <Grid>
              <ul style={{ marginTop: '0px' }}>
                {INCOME_TAB_DOCUMENT_LIST?.slice(0, intialProof).map((el) => {
                  return <li key={el.value}>{t(el.value)}</li>;
                })}
              </ul>
            </Grid>
            <Grid>
              <Typography
                style={{ color: '#0F99D6', cursor: 'pointer' }}
                onClick={() => {
                  setShowMoreDocuments(!showMoreDocuments);
                  intialProof == 3
                    ? setIntialProof(INCOME_TAB_DOCUMENT_LIST?.length)
                    : setIntialProof(3);
                }}
              >
                {showMoreDocuments
                  ? t(`Hide Document`)
                  : t('View More Document Examples')}
              </Typography>
            </Grid>
          </Grid>
          <Grid>
            <Grid>
              <Typography>{t("Choose any method below")}</Typography>
            </Grid>
            <Grid>
              <DocumentCapture
                setResidenceDoc={setResidenceDoc}
                setFileSize={setFileSize}
                setFileType={setFileType}
              />
            </Grid>
            <Grid>{renderFileUploadSection()}</Grid>
          </Grid>
          <Grid></Grid>
          {showResidenceVerfDocument && renderUploadedDocument()}
          {/* Address Input Fields */}
          {renderIncomeInputFields()}
          {/* Note Section */}
          <Grid style={{ marginTop: '20px' }}>
            <Typography>
              <strong>{t("NOTE: ")}</strong>{t("If you prefer to continue with a store coworker, please call or visit your store.")}
            </Typography>
          </Grid>

          {renderNavigationButtons()}
        </Grid>
      </Grid>
    </>
  );

  function renderFileUploadSection() {
    return (
      <Paper
        className={`${classes.drapNDropStyling} ${classes.w91p} ${classes.mb20px}`}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <UploadIcon className={`${classes.mt20px} ${classes.mb15px}`} />
        </Box>
        <label>
          <input
            type="file"
            accept=".png,.jpeg,.jpg,.pdf"
            multiple
            onChange={(e) => {
              handleFileChange(e);
              e.target.value = null;
            }}
            style={{ display: 'none' }}
          />
          <Typography
            variant="body2"
            component="span"
            color="primary"
            className={`${classes.underline} ${classes.cursorPointer} ${classes.primaryFontColor} ${classes.font16px}`}
          >
            {t("Choose a file or drag it here")}
          </Typography>
        </label>
        <Typography
          variant="body2"
          className={`${classes.mt10px} ${classes.lightGreyColor} ${classes.font14px} ${classes.p10px}`}
        >
          {t("JPEG, PNG, PDF up to 5MB")}
        </Typography>
      </Paper>
    );
  }

  function renderUploadedDocument() {
    return (
      <Grid
        style={{
          width: '100%',
          textAlign: 'left',
          padding: '10px',
          display: 'flex',
          paddingTop: '0px',
          cursor: 'pointer',
        }}
      >
        {fileType &&
          (fileType === 'image/png' || fileType === 'image/jpeg') && (
            <ImageIcon style={{ width: '20px', height: '20px' }} />
          )}
        {fileType && fileType === 'application/pdf' && (
          <PdfIcon style={{ width: '20px', height: '20px' }} />
        )}
        <Typography
          className={`${classes.primaryFontColor} ${classes.pl10px}`}
          onClick={() => {
            setOpenPdf(true);
          }}
        >
          {t("Proof of Income")}{' '}
          <span className={`${classes.fileSizeColor}`}>{fileSize}</span>
        </Typography>
        <DeleteIcon
          style={{
            width: '15px',
            height: '15px',
            marginLeft: '10px',
            marginTop: '3px',
          }}
          onClick={() => {
            setShowResidenceVerfDocument?.(false);
            setResidenceDoc?.('');
          }}
        />
        <RACModalCard
          borderRadius="15px"
          closeIcon={true}
          isOpen={openPdf}
          maxWidth={'sm'}
          className={`${classes.customModal}`}
          title={t(`Proof of Income`)}
          onClose={() => setOpenPdf(false)}
        >
          {pdfModelContent()}
        </RACModalCard>
      </Grid>
    );
  }

  function renderIncomeInputFields() {
    return (
      <>
        {/* Address Input Fields */}
        <Grid container spacing={3} style={{ marginTop: '20px' }}>
          {/* Type of Income Proof */}
          <Grid md={4} item sm={12} xs={12}>
            <RACSelect
              inputLabel={t("Type of Income Proof")}
              defaultValue={incomeInformation?.typeOfIncomeProof}
              name="typeOfIncomeProof"
              required={true}
              onChange={(e) => handleInputChange(e, 'typeOfIncomeProof')}
              options={typeOfIncomeOptions}
            />
          </Grid>

          {/* Company Name */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Company Name")}
              required={true}
              value={incomeInformation?.companyName}
              name="companyName"
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.companyName)} // Adjusted to show error message
              maxlength={30}
            />
          </Grid>

          {/* Joining Date */}
          <Grid md={4} item sm={12} xs={12}>
            {featureFlagDetails?.DateTimeLocalization == '1' ?
              <div className={classes.MUIDatePicker}>
                <RACMUIDatePicker
                  label={t('Joining Date')}
                  inputProps={{
                    min: '1900-01-01',
                    max: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
                  }}
                  value={incomeInformation?.joiningDate}
                  onChange={(date: string) => handleDateChange(date)}
                  required={true}
                  errorMessage={t(errorMessages.joiningDate)}
                  dateFormat={dateFormat}
                />
              </div>
              :
              <RACDatePicker
                label={t('Joining Date')}
                inputProps={{
                  min: '1900-01-01',
                  max: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
                }}
                value={incomeInformation?.joiningDate}
                onChange={(date: string) => handleDateChange(date)}
                required={true}
                errorMessage={t(errorMessages.joiningDate)}
                dateFormat={dateFormat}
              />
            }

          </Grid>
        </Grid>

        {/* Additional Address Fields */}
        <Grid container spacing={3} style={{ marginTop: '20px' }}>
          {/* Net Monthly Income */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              type='number'
              isCurrency={true}
              digitFormat={'currency'}
              required={true}
              inputlabel={t("Net Monthly Income")}
              value={incomeInformation?.netMonthlyIncome}
              name="netMonthlyIncome"
              OnChange={handleInputChange}
              maxlength={6}
            />
          </Grid>

          {/* Job Position */}
          <Grid md={4} item sm={12} xs={12}>
            <RACTextbox
              inputlabel={t("Job Position")}
              value={incomeInformation?.jobPosition}
              name="jobPosition"
              required={true}
              OnChange={handleInputChange}
              errorMessage={t(errorMessages.jobPosition)} // Adjusted to show error message
              maxlength={30}
            />
          </Grid>

          {/* Job Type */}
          <Grid md={4} item sm={12} xs={12}>
            <RACSelect
              inputLabel={t("Job Type")}
              defaultValue={incomeInformation?.jobType}
              name="jobType"
              required={true}
              onChange={(e) => handleInputChange(e, 'jobType')}
              options={jobTypeOptions}
            />
          </Grid>
        </Grid>
      </>
    );
  }

  function renderNavigationButtons() {
    return (
      <>
        <Grid style={{ float: 'left' }}>
          <RACButton
            variant="outlined"
            color="primary"
            style={{
              padding: '12px 30px',
              borderRadius: '5px',
              marginTop: '25px',
            }}
            onClick={() => {
              history.push('/residence');
            }}
          >
            {t("Back")}
          </RACButton>
        </Grid>

        <Grid style={{ float: 'right' }}>
          <RACButton
            variant="contained"
            color="primary"
            style={{
              padding: '12px 30px',
              borderRadius: '5px',
              marginTop: '25px',
            }}
            onClick={() => {
              IncomeNextClick();
            }}
            disabled={!isNextEnabled}
          >
            {t("Next")}
          </RACButton>
        </Grid>
      </>
    );
  }
};

export default IncomeTab;
